function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-arrow-circle-right-clip"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 4199",
    style: {
      fill: "#039"
    },
    d: "M0 0h18v18H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10616",
    style: {
      clipPath: "url(#icon-arrow-circle-right-clip)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9873",
    d: "M9 0a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 17.238A8.238 8.238 0 1 1 17.238 9 8.249 8.249 0 0 1 9 17.238",
    style: {
      fill: "#039"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9874",
    d: "M15 10.415a.363.363 0 0 0-.083-.124L11.3 6.674a.381.381 0 1 0-.539.539l2.966 2.967H5.9a.381.381 0 0 0 0 .762h7.831l-2.966 2.967a.381.381 0 1 0 .539.538l3.616-3.616a.371.371 0 0 0 .08-.124.378.378 0 0 0 0-.291",
    transform: "translate(-1.311 -1.56)",
    style: {
      fill: "#039"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowCircleRight);
export default __webpack_public_path__ + "static/media/icon-arrow-circle-right.b36639c3237ca814ffeed86850f5f5a2.svg";
export { ForwardRef as ReactComponent };